import { render, staticRenderFns } from "./inairhistoryedata.vue?vue&type=template&id=388e96f0&scoped=true&"
import script from "./inairhistoryedata.vue?vue&type=script&lang=ts&"
export * from "./inairhistoryedata.vue?vue&type=script&lang=ts&"
import style0 from "./inairhistoryedata.vue?vue&type=style&index=0&id=388e96f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e96f0",
  null
  
)

export default component.exports